import { itiMessageService, itiPermissionService, itiTokenService } from '@/iti-core-vue';
import templatesModule from '@/store/modules/templates.module';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { validate, ValidationProvider } from 'vee-validate';
import { Field } from '@/shared/dtos/field';
import { ItiIconButton, ItiVHeader } from '@/iti-core-vuetify';
import DxSelectBox from 'devextreme-vue/select-box';
import DxTextBox from 'devextreme-vue/text-box';
import DxNumberBox from 'devextreme-vue/number-box';
import DxTextArea from 'devextreme-vue/text-area';
import DxButton from 'devextreme-vue/button';
import DxDropDownBox from 'devextreme-vue/drop-down-box';
import DxTreeView from 'devextreme-vue/tree-view';
import DxCheckBox from 'devextreme-vue/check-box';
import { DxDataGrid, DxSelection, DxPaging, DxFilterRow, DxScrolling } from 'devextreme-vue/data-grid';
import DxValidationSummary from 'devextreme-vue/validation-summary';
import {
    DxValidator,
    DxRequiredRule,
    DxCompareRule,
    DxStringLengthRule,
} from 'devextreme-vue/validator';
import { Permission } from '@/shared/permissions';

@Component({
    components: {
        ValidationProvider,
        ItiIconButton,
        DxSelectBox,
        DxTextBox,
        DxNumberBox,
        DxTextArea,
        DxButton,
        DxValidator,
        DxRequiredRule,
        DxCompareRule,
        DxStringLengthRule,
        DxValidationSummary,
        DxDropDownBox,
        DxTreeView,
        DxCheckBox,
        DxDataGrid,
        DxSelection,
        DxPaging,
        DxFilterRow,
        DxScrolling
    },
})

export default class PlantillaFormulario extends Vue {
    @Prop() idPlantilla !: number;
    @Prop() idVersion !: number;
    public loading = false;
    public search = "";

    public get headers() {
        return [
            new ItiVHeader('code', 'plantillas.fieldCode'),
            new ItiVHeader('label', 'plantillas.fieldLabel'),
            new ItiVHeader('fieldType.code', 'plantillas.fieldTypecode'),
            new ItiVHeader('description', 'plantillas.fieldDescription').withWidth(300),
            // new ItiVHeader('action', '').withWidth(50),
        ];
    }

    public get editTemplateVersion() {
        return templatesModule.selectedTemplateVersion;
    }

    public get fields() {
        return templatesModule.templateFields;
    }

    public get templateTitle() {
        if (templatesModule.selectedTemplate.title == null || templatesModule.selectedTemplate.title.length == 0) {
            return this.$t('plantillas.nuevaPlantilla');
        } else {
            return templatesModule.selectedTemplate.title;
        }
    }

    public get hasPermission() {
        return itiPermissionService.hasPermission(Permission.updateTemplates);
    }

    public get numVersion() {
        return this.editTemplateVersion.version
    }

    public goToListListVersions(){
        this.$router.push({ name: 'ListaVersiones', params: { id: this.idPlantilla.toString() } })
    }

    public created() {
        if (!isNaN(this.idVersion) && this.idVersion != 0) {
            templatesModule.getTemplateVersionById(this.idVersion).then(() => {
            });
        } 
        if (!isNaN(this.idPlantilla) && this.idPlantilla != 0) {
            templatesModule.getTemplateById(this.idPlantilla).then(() => {
            });
        }
    }

    public mounted() {
        // 
    }

    public formattedContent(contenido: string) {
        if (contenido && contenido.length > 40) {
            return String(contenido).substring(0, 40) + "...";
        } else {
            return contenido;
        }
    }

    public translateState(active: boolean) {
        return this.$tc(active.toString());
    }
}